import { ELEMENT_ATTRIBUTE_GROUP, ELEMENT_GROUPS } from './../utils';

const IconElementFields = {
  group: ELEMENT_GROUPS.MEDIA,
  label: 'Icon',
  icon: 'PhotographIcon',
  description: 'Add an icon to the screen',
  properties: [
    'layout',
    {
      label: 'On Press Action',
      name: 'action',
      editor: 'dropdown',
      default: '',
      description: 'An action to run when the icon is pressed.',
      options: [],
      function: {
        name: 'getAppActions',
        params: ['app.id']
      },

      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Icon Source Field',
      name: 'sourceField',
      editor: 'dropdown',
      description:
        'The field from the underlying record that will be used for the icon',
      default: '',
      options: [],
      function: {
        name: 'getDynamicDataSourceFields',
        params: ['app.id', 'datasourceId']
      },
      displayWhen: [
        {
          field: 'datasourceId',
          operator: 'IS_NOT_EMPTY',
          value: []
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Icon',
      name: 'icon',
      editor: 'icon',
      description: 'The icon that will be used',
      default: '',
      displayWhen: [
        {
          field: 'datasourceId',
          operator: 'IS_EMPTY',
          value: []
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
    },
    'iconsize',
    'color',
    'alignment',
    'margin',
    'padding',
    'text',
    'fontFamily',
    'font'
  ]
};

export default IconElementFields;
